export function Drawer({ open, title, onClose, children, width = 480 }) {
  return (
    <>
      <div
        className={[
          "fixed inset-0 z-40 bg-black/40 transition-opacity duration-300",
          open
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none",
        ].join(" ")}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        role="dialog"
        aria-modal="true"
        className={[
          "fixed inset-y-0 right-0 z-50 h-screen bg-white dark:bg-slate-900 dark:text-white shadow-xl",
          "transform transition-transform duration-300 ease-out",
          open ? "translate-x-0" : "translate-x-full",
        ].join(" ")}
        style={{ width, willChange: 'transform' }}
      >
        <header className="flex items-center justify-between border-b dark:border-[#c4c4c432] px-4 py-3">
          <h2 className="text-base font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded hover:bg-black/5 dark:hover:bg-white/10"
            aria-label="Close panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </button>
        </header>
        <div 
          className="h-[calc(100vh-52px)] overflow-y-auto p-4"
          style={{ overflowX: 'visible' }}
        >
          {children}
        </div>
      </aside>
    </>
  );
}
